export const DEFAULT_PRELOAD_COUNT = 8;

// 500 ms timeout for each macro loading task, as this is the value the feature
// was rolled out with. On staging, we use 1000 ms to avoid test flakiness.
export const DEFAULT_LOAD_TIMEOUT = process.env.CLOUD_ENV === 'staging' ? 1000 : 500;

// Block problematic extensions on server rendering; FF is stringly-typed, macro names
// in the FF are comma-separated, such as "jira,include,decisionReport"
export const FF_SSR_EXTENSIONS_BLOCKLIST =
	'confluence.frontend.extensions.server-render-top-x.blocklist';
